import { ButtonSecondary, UploadAction } from './styled';
import { CloseIcon, EyeIcon, ImageIcon, TrashIcon } from '@/assets/svg';
import Image from '@/components/Image';
import UploadCompAnt from '@/components/UploadCompAnt';
import { blobUrl } from '@/helpers';
import {
  Box,
  Button,
  Typography,
  withStyles,
  DialogContent,
  makeStyles,
  Dialog,
  IconButton,
} from '@material-ui/core';
import React, { useState } from 'react';

const UploadText = withStyles({
  root: {
    color: '#333333',
  },
})(Typography);

const CustomIconButton = withStyles({
  root: {
    minWidth: 'unset',
    width: 36,
    height: 36,
    '&.MuiButton-outlined': {
      padding: 0,
    },
  },
})(Button);

const PreviewContent = withStyles({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(51,51,51,0.4)',
    borderRadius: 8,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
})(Box);

const CustomDialogContent = withStyles({
  root: {
    padding: 40,
    position: 'relative',
    '& .icon': {
      position: 'absolute',
      top: 10,
      right: 10,
    },

    '&:first-child': {
      paddingTop: 40,
    },
  },
})(DialogContent);

const useStyles = makeStyles({
  image: {
    width: (props) => props.width,
    height: (props) => props.height,
    borderRadius: 8,
  },
});

const UploadImageContainer = ({
  imageUrl,
  setFormValue,
  formValue,
  handleChangeForm,
  name,
  width = 141,
  height = 141,
  text = 'Recommended format: PNG or JPEG',
  accept = 'image/*',
  onDelete,
}) => {
  const classes = useStyles({ width, height });

  const [isHovered, setIsHovered] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const handlePreviewOpen = () => {
    setPreviewOpen(true);
    handleMouseLeave();
  };
  const handlePreviewClose = () => setPreviewOpen(false);
  const isPdf =
    imageUrl &&
    (typeof imageUrl === 'string'
      ? imageUrl.toLowerCase().endsWith('.pdf') || imageUrl.includes('.pdf')
      : imageUrl.type === 'application/pdf');
  const fileUrl = imageUrl
    ? typeof imageUrl === 'object'
      ? blobUrl(imageUrl)
      : imageUrl
    : null;

  return (
    <Box display="flex" gridGap={20}>
      <Box
        position="relative"
        onMouseEnter={() => handleMouseEnter('front')}
        onMouseLeave={handleMouseLeave}
      >
        {imageUrl ? (
          <>
            {isPdf ? (
              <Box
                width={width}
                height={height}
                bgcolor="#f6f6f6"
                border="1px solid #e1e1e1"
                borderRadius="8px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                overflow="hidden"
              >
                <iframe
                  src={fileUrl}
                  width={width}
                  height={height}
                  style={{ border: 'none' }}
                  title="PDF Preview"
                />
              </Box>
            ) : (
              <Image src={fileUrl} alt="Preview" className={classes.image} />
            )}
            {isHovered && (
              <PreviewContent
                width={width}
                height={height}
                onClick={handlePreviewOpen}
              >
                <EyeIcon color="white" width={24} height={24} />
              </PreviewContent>
            )}
          </>
        ) : (
          <Box
            width={width}
            height={height}
            bgcolor="#f6f6f6"
            border="1px solid #e1e1e1"
            borderRadius="8px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <ImageIcon />
          </Box>
        )}
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        gridGap={16}
      >
        <Box>
          {/* <UploadText>
            Upload a portrait of the counsellor with a clear background
          </UploadText> */}
          <UploadText>{text}</UploadText>
        </Box>
        <Box display="flex" gridGap={16}>
          {imageUrl && (
            <CustomIconButton
              color="primary"
              variant="outlined"
              onClick={() => {
                onDelete
                  ? onDelete()
                  : setFormValue({ ...formValue, [name]: '' });
              }}
            >
              <TrashIcon />
            </CustomIconButton>
          )}
          <UploadCompAnt
            isAddNew={true}
            label="Upload banner"
            fileData={imageUrl}
            onChange={handleChangeForm}
            editable={true}
            accept={accept}
            ActionComponent={
              <UploadAction>
                <ButtonSecondary>
                  {imageUrl ? 'Replace' : 'Upload'}
                </ButtonSecondary>
              </UploadAction>
            }
          />
        </Box>
      </Box>
      {previewOpen && (
        <Dialog
          disableBackdropClick
          open={previewOpen}
          onClose={handlePreviewClose}
          maxWidth="lg"
        >
          <CustomDialogContent>
            <IconButton className="icon" onClick={handlePreviewClose}>
              <CloseIcon />
            </IconButton>

            {isPdf ? (
              <iframe
                src={fileUrl}
                style={{ border: 'none', width: '800px', height: '80vh' }}
                title="PDF Preview"
              />
            ) : (
              <Image src={fileUrl} alt="Preview" />
            )}
          </CustomDialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default UploadImageContainer;
